// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-amo[data-v-1dfa6d5a],.card-contact[data-v-1dfa6d5a],.card-customer[data-v-1dfa6d5a]{min-width:400px;display:flex;flex-direction:column;margin-bottom:2rem}.row-bg[data-v-1dfa6d5a]{flex-wrap:wrap}", ""]);
// Exports
module.exports = exports;
